import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "ユーザー一覧", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "col-3" }),
  /*#__PURE__*/_createElementVNode("th", { class: "col-5" }, "ログインID"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }, "通知状態"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }, "権限")
], -1)
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_19 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_20 = {
  key: 2,
  class: "badge badge-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_content_layout = _resolveComponent("list-content-layout")!
  const _component_user_update_dialog = _resolveComponent("user-update-dialog")!
  const _component_confirm_delete_modal = _resolveComponent("confirm-delete-modal")!
  const _component_confirm_send_welcome_mail = _resolveComponent("confirm-send-welcome-mail")!
  const _component_confirm_send_welcome_mail_all_user = _resolveComponent("confirm-send-welcome-mail-all-user")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_list_content_layout, null, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      operation: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-primary ml-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showingAddModal = true))
          }, "追加"),
          _createElementVNode("button", {
            class: "btn btn-warning ml-5",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showingSendAllUser = true))
          }, "ユーザー作成メールの一斉送信")
        ]),
        (_ctx.requestError)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "alert alert-danger",
              textContent: _toDisplayString(_ctx.requestError)
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      "table-header": _withCtx(() => [
        _hoisted_4
      ]),
      "table-body": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (u) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: u.key
          }, [
            _createElementVNode("td", _hoisted_5, [
              (u.notSendWelcomeMail)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-outline-info",
                    onClick: ($event: any) => (_ctx.mailTargetUser = u)
                  }, " 新規ユーザーメールを送信 ", 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-warning ml-2",
                onClick: ($event: any) => (_ctx.modifyTargetUser = u)
              }, _hoisted_9, 8, _hoisted_7),
              _createElementVNode("button", {
                class: "btn btn-danger ml-2",
                onClick: ($event: any) => (_ctx.deleteTargetUser = u)
              }, _hoisted_12, 8, _hoisted_10)
            ]),
            _createElementVNode("td", {
              textContent: _toDisplayString(u.loginId)
            }, null, 8, _hoisted_13),
            _createElementVNode("td", _hoisted_14, [
              (u.notSendWelcomeMail)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "ユーザー作成メール未通知"))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, "ユーザー作成メール通知済み"))
            ]),
            _createElementVNode("td", _hoisted_17, [
              (u.isAdmin)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "管理者"))
                : (u.isSystem)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "システム"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, "一般ユーザー"))
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showingAddModal)
          ? (_openBlock(), _createBlock(_component_user_update_dialog, {
              key: 0,
              onDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showingAddModal = false)),
              onUpdated: _ctx.onUpdated,
              "is-add": true
            }, null, 8, ["onUpdated"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modifyTargetUser)
          ? (_openBlock(), _createBlock(_component_user_update_dialog, {
              key: 0,
              onUpdated: _ctx.onUpdated,
              "is-add": false,
              "target-obj": _ctx.modifyTargetUser,
              onDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modifyTargetUser = null))
            }, null, 8, ["onUpdated", "target-obj"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.deleteTargetUser)
          ? (_openBlock(), _createBlock(_component_confirm_delete_modal, {
              key: 0,
              "target-obj": _ctx.deleteTargetUser,
              "target-name": _ctx.deleteTargetUser.loginId,
              onShouldDelete: _ctx.deleteUser,
              onDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteTargetUser = null))
            }, null, 8, ["target-obj", "target-name", "onShouldDelete"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.mailTargetUser)
          ? (_openBlock(), _createBlock(_component_confirm_send_welcome_mail, {
              key: 0,
              "login-id": _ctx.mailTargetUser.loginId,
              "user-key": _ctx.mailTargetUser.key,
              onDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mailTargetUser = null)),
              onSend: _ctx.updateList
            }, null, 8, ["login-id", "user-key", "onSend"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showingSendAllUser)
          ? (_openBlock(), _createBlock(_component_confirm_send_welcome_mail_all_user, {
              key: 0,
              onDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showingSendAllUser = false)),
              onSend: _ctx.updateList
            }, null, 8, ["onSend"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}